(function(){
'use strict';
/* BUSHLINE 28 Sep 2026: progress ring is BushLine yellow (#F0CC3D, the header
   icon colour) so the scroll progress is easy to see; red (#E5484D, until 27 Sep)
   and aqua (#73CFD8, 27 Sep) were too faint on the dark page, and red beside the
   green button is hard for colour-blind eyes. Band kept at the original 3 (a 4.5
   trial looked heavy). */
var RING_W='3';
var SHOW_AT=200,RING_COLOR='#F0CC3D',RING_TRACK='rgba(255,255,255,0.22)',SZ=64,BTN=44,R=28,CX=32,CY=32;
var C=+(2*Math.PI*R).toFixed(2);
var EDGE_BOTTOM='max(10px, env(safe-area-inset-bottom, 0px))';

function smoothTop(){
  var start=window.pageYOffset||document.documentElement.scrollTop||0;
  if(!start)return;
  var dur=700,t0=null;
  function step(ts){
    if(!t0)t0=ts;
    var p=Math.min((ts-t0)/dur,1);
    var e=1-Math.pow(1-p,3);
    window.scrollTo(0,Math.round(start*(1-e)));
    if(p<1)requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

/* Detect sticky ATC bar height (mobile product pages only) */
function stickyBarH(){
  var sel=[
    '.product-sticky-atc','.sticky-atc','.sticky-add-to-cart',
    '[data-sticky-atc]','.product-form--sticky','.product-sticky-bar',
    '.js-sticky-header ~ .sticky-atc-bar'
  ];
  for(var i=0;i<sel.length;i++){
    var el=document.querySelector(sel[i]);
    if(el){
      var r=el.getBoundingClientRect();
      if(r.height>10 && r.bottom>=window.innerHeight-5) return Math.ceil(r.height);
    }
  }
  return 0;
}

/* BUSHLINE: an existing platform-level custom CSS rule
   ("#bl-btt-wrap { bottom: 20px !important; }") pins this wrapper's bottom
   offset with !important, which beats a plain (non-important) inline style.
   Setting our own inline value with 'important' priority restores our
   control, since an important inline style outranks an important
   stylesheet rule in the cascade. */
function setBottom(wrap){
  var atc=window.innerWidth<768?stickyBarH():0;
  if(atc>0){
    wrap.style.setProperty('bottom',(atc+12)+'px','important');
    return;
  }
  if(window.innerWidth<768){
    var chatCenter=getChatCenterFromViewportBottom();
    if(chatCenter!==null){
      var desired=Math.max(0,chatCenter-(wrap.offsetHeight/2));
      wrap.style.setProperty('bottom',desired+'px','important');
      return;
    }
  }
  wrap.style.setProperty('bottom',EDGE_BOTTOM,'important');
}

/* BUSHLINE: best-effort nudge of the Shopify Inbox chat launcher so it sits
   at the same low bottom offset as our own back-to-top button, instead of
   whatever "lowest" preset the app defaults to. This reaches into the
   <shopify-chat> element's own (open) shadow root and overrides just the
   inline "bottom" position on its activator-nudge wrapper. It's app-owned
   markup we don't control, so this is wrapped defensively and re-applied a
   few times after load (and once on resize) in case the widget re-renders;
   if Shopify changes that markup this silently no-ops rather than erroring. */
function syncChatBottom(){
  try {
    var chatEl=document.querySelector('shopify-chat');
    var root=chatEl&&chatEl.shadowRoot;
    if(!root)return;
    var nudges=root.querySelectorAll('[class*="activator-nudge"]');
    nudges.forEach(function(n){
      n.style.setProperty('bottom',EDGE_BOTTOM,'important');
    });
  } catch(e) {}
}

function getChatCenterFromViewportBottom(){
  try {
    var chatEl=document.querySelector('shopify-chat');
    var root=chatEl&&chatEl.shadowRoot;
    if(!root)return null;
    var nudge=root.querySelector('[class*="activator-nudge"]');
    if(!nudge)return null;
    var r=nudge.getBoundingClientRect();
    if(r.height<5)return null;
    return (window.innerHeight-r.bottom)+(r.height/2);
  } catch(e) {
    return null;
  }
}

function syncAll(wrap){
  syncChatBottom();
  setBottom(wrap);
}

function init(){
  var old=document.getElementById('bushline-btt');
  if(old) old.style.setProperty('display','none','important');

  /* Wrapper */
  var wrap=document.createElement('div');
  wrap.id='bl-btt-wrap';
  wrap.setAttribute('aria-hidden','true');
  wrap.style.cssText='position:fixed;right:16px;z-index:9999;width:'+SZ+'px;height:'+SZ+'px;opacity:0;transition:opacity 0.35s ease;pointer-events:none;';

  /* SVG ring */
  var ns='http://www.w3.org/2000/svg';
  var svg=document.createElementNS(ns,'svg');
  svg.setAttribute('width',SZ);svg.setAttribute('height',SZ);
  svg.setAttribute('viewBox','0 0 '+SZ+' '+SZ);
  svg.style.cssText='position:absolute;top:0;left:0;pointer-events:none;transform:rotate(-90deg);';

  var track=document.createElementNS(ns,'circle');
  track.setAttribute('cx',CX);track.setAttribute('cy',CY);track.setAttribute('r',R);
  track.setAttribute('fill','none');track.setAttribute('stroke',RING_TRACK);track.setAttribute('stroke-width',RING_W);

  var arc=document.createElementNS(ns,'circle');
  arc.setAttribute('cx',CX);arc.setAttribute('cy',CY);arc.setAttribute('r',R);
  arc.setAttribute('fill','none');arc.setAttribute('stroke',RING_COLOR);arc.setAttribute('stroke-width',RING_W);
  arc.setAttribute('stroke-linecap','round');
  arc.style.strokeDasharray=C;
  arc.style.strokeDashoffset=C;
  arc.style.transition='stroke-dashoffset 0.12s linear';

  svg.appendChild(track);svg.appendChild(arc);

  /* Button — 44px centered in 64px wrapper */
  var pad=Math.round((SZ-BTN)/2);
  var btn=document.createElement('button');
  btn.id='bl-btt-btn';
  btn.setAttribute('aria-label','Back to top');
  btn.style.cssText='position:absolute;top:'+pad+'px;left:'+pad+'px;width:'+BTN+'px;height:'+BTN+'px;border-radius:50%;background:#35a956;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 3px 10px rgba(0,0,0,0.4);transition:transform 0.2s ease,box-shadow 0.2s ease;';
  btn.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>';

  btn.addEventListener('mouseenter',function(){this.style.transform='scale(1.07)';this.style.boxShadow='0 5px 15px rgba(53,169,86,0.55)';});
  btn.addEventListener('mouseleave',function(){this.style.transform='';this.style.boxShadow='0 3px 10px rgba(0,0,0,0.4)';});
  btn.addEventListener('click',smoothTop);

      if(!document.getElementById('bl-btt-style')){
        var style=document.createElement('style');
        style.id='bl-btt-style';
        style.textContent='#bl-btt-btn{outline:none;}#bl-btt-btn:focus-visible{outline:2px solid rgba(255,255,255,0.8);outline-offset:2px;}';
        document.head.appendChild(style);
      }

  wrap.appendChild(svg);
  wrap.appendChild(btn);
  document.body.appendChild(wrap);

  /* Initial bottom position check */
  setBottom(wrap);
  window.addEventListener('resize',function(){setBottom(wrap);},{passive:true});

  /* Try to align the Chat launcher a few times as it loads/settles, and
     re-sync bottom position together so the two stay aligned. */
  syncAll(wrap);
  setTimeout(function(){syncAll(wrap);},500);
  setTimeout(function(){syncAll(wrap);},1500);
  setTimeout(function(){syncAll(wrap);},3000);
  window.addEventListener('resize',function(){syncAll(wrap);},{passive:true});

  /* Scroll */
  var visible=false,ticking=false;
  function update(){
    ticking=false;
    var scrolled=window.pageYOffset||document.documentElement.scrollTop||0;
    var maxScroll=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
    var pct=Math.min(1,scrolled/maxScroll);

    arc.style.strokeDashoffset=+(C*(1-pct)).toFixed(2);

    /* Re-check ATC bar on scroll (may appear/disappear) */
    setBottom(wrap);

    var show=scrolled>SHOW_AT;
    if(show!==visible){
      visible=show;
      wrap.style.opacity=show?'1':'0';
      wrap.style.pointerEvents=show?'auto':'none';
      wrap.setAttribute('aria-hidden',show?'false':'true');
    }

    /* Chat bubble sync */
    var chat=document.getElementById('shopify-chat');
    if(chat){
      chat.style.transition='opacity 0.35s ease';
      chat.style.opacity=show?'1':'0';
      chat.style.pointerEvents=show?'auto':'none';
    }
  }

  window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(update);}},{passive:true});
  update();
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
} else {
  init();
}
})();